import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, Col } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import CustomSurveyReportApi from 'apis/reports/CustomSurveyReport';

class ReportShare extends Component {
  constructor() {
    super();

    this.state = {
      text: 'Export',
      icon: 'download',
      exporting: false,
      buttonDisable: false,
    };
  }

  changeButtonText = (text, icon, exporting, buttonDisable) => {
    this.setState({ text, icon, exporting, buttonDisable });
    this.generatepdf();
  };

  generatepdf = () => {
    const { customSurveyId } = this.props;
    CustomSurveyReportApi.getPdf(customSurveyId).then(pdf => {
      window.location.href = pdf.request.responseURL;
      this.setState({
        text: 'Export',
        icon: 'download',
        buttonDisable: false,
        exporting: false,
      });
    });
  };

  render() {
    const { text, icon, buttonDisable, exporting } = this.state;
    const { reportShareToggle, disableShareReport } = this.props;
    const hidden = disableShareReport;

    return (
      <Col
        md={{ size: 6 }}
        className={`${hidden ? 'd-none' : ''} report-share-top-col`}
      >
        <Col md={{ size: 12 }} className="report-share-bottom-col">
          <Button
            color="#cccccc"
            onClick={() => {
              this.changeButtonText('Exporting...', 'spinner', true, true);
            }}
            className="report-button report-button-export"
            disabled={buttonDisable}
          >
            <FontAwesomeIcon icon={icon} pulse={exporting} />
            <span>{text}</span>
          </Button>
          <Button
            color="#cccccc"
            className="report-button"
            onClick={reportShareToggle.bind(this)}
          >
            <FontAwesomeIcon icon="share-alt" />
            Share
          </Button>
        </Col>
      </Col>
    );
  }
}

ReportShare.propTypes = {
  reportShareToggle: PropTypes.func,
  disableShareReport: PropTypes.bool,
  customSurveyId: PropTypes.string,
};

export default ReportShare;



// WEBPACK FOOTER //
// ./src/components/reports/ReportShare.js